import { Box, Skeleton } from "@mui/material";
import baseStyles from "../../detail/style.module.scss";

function SkeletonLoader() {
  return (
    <div>
      <Box className={baseStyles.infoCard}>
        <div className={baseStyles.infoTop}>
          <div className={baseStyles.infoLeft}>
            <Skeleton variant="circular" width={56} height={56} />
            <div className={baseStyles.infoMeta}>
              <Skeleton
                variant="rectangular"
                width={220}
                height={24}
                sx={{ borderRadius: "4px", marginBottom: "10px" }}
              />
              <div className={baseStyles.metaRow}>
                {Array.from({ length: 2 }).map((_, i) => (
                  <div key={i} className={baseStyles.metaCol}>
                    <Skeleton
                      variant="rectangular"
                      width={50}
                      height={12}
                      sx={{ borderRadius: "4px", marginBottom: "6px" }}
                    />
                    <Skeleton
                      variant="rectangular"
                      width={130}
                      height={16}
                      sx={{ borderRadius: "4px" }}
                    />
                  </div>
                ))}
              </div>
            </div>
          </div>
          <div className={baseStyles.infoActions}>
            <Skeleton
              variant="rectangular"
              width={110}
              height={36}
              sx={{ borderRadius: "20px" }}
            />
          </div>
        </div>

        <hr className={baseStyles.divider} />

        <div className={baseStyles.infoIconRow}>
          {Array.from({ length: 5 }).map((_, i) => (
            <div key={i} className={baseStyles.infoIconItem}>
              <Skeleton variant="circular" width={18} height={18} />
              <Skeleton
                variant="rectangular"
                width={120}
                height={14}
                sx={{ borderRadius: "4px" }}
              />
            </div>
          ))}
        </div>
      </Box>
    </div>
  );
}

export default SkeletonLoader;
